import React from 'react';

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import CustomInput from "components/CustomInput/CustomInput.jsx";

import Button from "components/CustomButtons/Button.jsx";
import InputAdornment from "@material-ui/core/InputAdornment";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import ErrorModal from "components/Modal/ErrorModal.jsx";

import { faCheck } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { CircularProgress } from "@material-ui/core";

import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";

import Email from "@material-ui/icons/Email";
import Phone from "@material-ui/icons/Phone";
import Api from '../../../../api/Api.js';
import CustomerEndpoints from '../../../../api/CustomerEndpoints';

const style = {
    infoText: {
        fontWeight: "300",
        margin: "10px 0 30px",
        textAlign: "center"
    },
    inputAdornmentIcon: {
        color: "#555"
    },
    inputAdornment: {
        position: "relative"
    }
};

export class ContactStateObject {
    name = "";
    nameState = "";
    surname = "";
    surnameState = "";
    contact_number = "";
    contact_numberState = "";
    email = "";
    emailState = "";
    isAdd = true;
    error = false;
}

class EditOrAddContact extends React.Component {

    constructor(props) {
        super(props)

        props.contact ?
            this.state = Object.assign(new ContactStateObject(), props.contact)
            :
            this.state = new ContactStateObject();

        this.state.loading = false;
        if (props.contact)
            this.state.isAdd = false;
    }

    verifyEmail(value) {
        var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (emailRex.test(value)) {
            return true;
        }
        return false;
    }
    verifyMobile(value) {
        var phoneRex = /^\d{10,20}$/
        if (phoneRex.test(value)) {
            return true;
        }
        return false;
    }
    verifyLength(value, length) {
        if (value.length >= length) {
            return true;
        }
        return false;
    }

    change = (event, name, type = "required") => {
        var new_state = { [name + "State"]: this.state[name + "State"] };

        switch (type) {
            case "required":
                if (event.target.value) {
                    new_state[name + "State"] = "success";
                } else {
                    new_state[name + "State"] = "error";
                }
                break;
            case "email":
                if (this.verifyEmail(event.target.value)) {
                    new_state[name + "State"] = "success";
                } else {
                    new_state[name + "State"] = "error";
                }
                break;
            case "phone":
                if (this.verifyMobile(event.target.value)) {
                    new_state[name + "State"] = "success";
                } else {
                    new_state[name + "State"] = "error";
                }
                break;
            default:
                break;
        }
        this.setState({ ...new_state, [name]: event.target.value });
    }

    submit() {
        if ((this.state.nameState === 'success' || (!this.state.nameState && !this.state.isAdd)) && 
            (this.state.surnameState === 'success' || (!this.state.surnameState && !this.state.isAdd)) &&
            (this.state.contact_numberState === 'success' || (!this.state.contact_numberState && !this.state.isAdd)) &&
            (this.state.emailState === 'success' || (!this.state.emailState && !this.state.isAdd))) {
            this.setState({ loading: true }, () =>
                Api.post(this.state.isAdd ? CustomerEndpoints.addContact : CustomerEndpoints.editContact, { customer_id: this.props.customer_id, contact: this.state, type: this.props.type })
                    .then(() => {
                        this.props.close();
                        this.props.refresh();
                        this.setState({ loading: false })
                    })
                    .catch((e) => this.setState({ loading: false, error: true }, () => console.error(e)))
            )
        } else if(this.state.isAdd) {

            var newState = {  };

            if(this.state.nameState !== 'success') {
                newState.nameState = 'error';
            }

            if(this.state.surnameState !== 'success') {
                newState.surnameState = 'error';
            }

            if(this.state.contact_numberState !== 'success') {
                newState.contact_numberState = 'error';
            }

            if(this.state.emailState !== 'success') {
                newState.emailState = 'error';
            }

            this.setState(newState)
        }
    }

    render() {

        const { classes } = this.props;

        return (
            <Dialog
                open={this.props.isOpen}
                onClose={this.props.close}
                fullWidth
                maxWidth="sm"
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="form-dialog-title">{this.state.isAdd ? "Add " : "Edit "}{this.props.type_name}</DialogTitle>
                <DialogContent>
                    <CustomInput
                        success={this.state.nameState === "success"}
                        error={this.state.nameState === "error"}
                        labelText={
                            <span>
                                Name <small>(required)</small>
                            </span>
                        }
                        id="name"
                        formControlProps={{
                            fullWidth: true
                        }}
                        inputProps={{
                            onChange: event => this.change(event, "name", "required"),
                            value: this.state.name,
                        }}
                    />
                    <CustomInput
                        success={this.state.surnameState === "success"}
                        error={this.state.surnameState === "error"}
                        labelText={
                            <span>
                                Surname <small>(required)</small>
                            </span>
                        }
                        id="surname"
                        formControlProps={{
                            fullWidth: true
                        }}
                        inputProps={{
                            onChange: event => this.change(event, "surname", "required"),
                            value: this.state.surname,
                        }}
                    />
                    <CustomInput
                        success={this.state.emailState === "success"}
                        error={this.state.emailState === "error"}
                        labelText={
                            <span>
                                Email <small>(required)</small>
                            </span>
                        }
                        id="email"
                        formControlProps={{
                            fullWidth: true
                        }}
                        inputProps={{
                            onChange: event => this.change(event, "email", "email"),
                            endAdornment: (
                                <InputAdornment
                                    position="end"
                                    className={classes.inputAdornment}
                                >
                                    <Email className={classes.inputAdornmentIcon} />
                                </InputAdornment>
                            ),
                            value: this.state.email,
                        }}
                    />
                    <CustomInput
                        success={this.state.contact_numberState === "success"}
                        error={this.state.contact_numberState === "error"}
                        labelText={
                            <span>
                                Contact Number <small>(required)</small>
                            </span>
                        }
                        id="contact_number"
                        formControlProps={{
                            fullWidth: true
                        }}
                        inputProps={{
                            onChange: event => this.change(event, "contact_number", "phone"),
                            endAdornment: (
                                <InputAdornment
                                    position="end"
                                    className={classes.inputAdornment}
                                >
                                    <Phone className={classes.inputAdornmentIcon} />
                                </InputAdornment>
                            ),
                            value: this.state.contact_number,
                        }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button style={{ marginRight: 'auto' }} round onClick={this.props.close} color="rose" simple>
                        Cancel
                    </Button>


                    {
                        this.state.loading ?
                            <CircularProgress color="secondary" style={{ marginBottom: 5, marginRight: 10 }} />
                            :
                            <Button
                                onClick={() => this.submit()}
                                color="rose"
                                round
                            >
                                {this.state.isAdd ? "Add " + this.props.type_name : "Save Changes"}
                                &nbsp;&nbsp;
                                <FontAwesomeIcon icon={faCheck} />
                            </Button>
                    }
                </DialogActions>
                <ErrorModal open={this.state.error} close={() => this.setState({ error: false })}>
                    Error! Could not save the contact you have provided, please ensure all required details are filled in.<br /><br />If all else fails, please refresh this page and try again or contact dev support.
                </ErrorModal>
            </Dialog>
        );
    }
}

export default withStyles({ ...extendedFormsStyle, ...style })(EditOrAddContact);